/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_License_Price_NoteInputs */

const en_marketing_license_price_note = /** @type {(inputs: Marketing_License_Price_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`one-time`)
};

const es_marketing_license_price_note = /** @type {(inputs: Marketing_License_Price_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pago único`)
};

const fr_marketing_license_price_note = /** @type {(inputs: Marketing_License_Price_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`paiement unique`)
};

/**
* | output |
* | --- |
* | "one-time" |
*
* @param {Marketing_License_Price_NoteInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_license_price_note = /** @type {((inputs?: Marketing_License_Price_NoteInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_License_Price_NoteInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_license_price_note(inputs)
	if (locale === "es") return es_marketing_license_price_note(inputs)
	return fr_marketing_license_price_note(inputs)
});